import $ from 'gridstrap/lib/gs-zepto';
import md5 = require('md5');
import { data } from '.';

export class GSData {

	private root;

	get id() { return this.root.data('gsDataId'); }
	get isAsync() { return this.root.hasClass('async'); }
	get value() { return this.root.html().trim(); }
	get hashKey() { return this.root.data('gsDataHashKey'); }

	constructor(root) {
		this.root = $(root);
	}

	private parse(str) {
		let obj = this.isBase64(str)
			? JSON.parse(atob(str))
			: JSON.parse(str)
		;

		if (!this.hashKey) return obj;

		if (Array.isArray(obj)) {
			obj.forEach(item => item[this.hashKey] = this.hash(item));
		} else {
			obj[this.hashKey] = this.hash(obj);
		}

		return obj;
	}

	private hash(item) {
		let str = (typeof item === 'object') ? JSON.stringify(item) : item;
		let hash = `${md5(str)}`;
		return hash.substring(0, 8);
	}

	private isBase64(str) {
		const pattern = /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/;
		return pattern.test(str);
	}

	private getData(id) {
		$['ajax']({
			data: `async=${id}`,
			success: value => this.setData(id, value)
		});
	}

	private setData(id, value) {
		try {
			data.set(id, this.parse(value));
			this.root.remove();

			if ($('.gs-Template, .gs-Data').length === 0) {
				$('.gsc-data').removeClass('gsc-data').gs('gsOnDataReady');
				$('body').trigger('gs:dataAndTemplatesReady');
			}
		} catch(e) {
			console.log(`Error parsing data: ${id}`);
		}
	}

	gsOnInit() {
		this.isAsync
			? this.getData(this.id)
			: this.setData(this.id, this.value);
		;
	}
}
